import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider, Typography, Spin } from 'antd';
import { ExcelIcon } from 'icons';
import { Link } from 'react-router-dom';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useStoreVsVillagePages from '../useInvoicesSalesTrends';
import LineChart from '../../../charts/lineChart';
import AlertMessage from '../../../components/alertMessage';
import UIHelper from '../../../../../helpers/UIHelper';
import Helpers from '../../../../../helpers';

const MainPage = () => {
  const {
    data,
    columns,
    filters,
    summary,
    loading,
    handleDownloadExcel,
    title,
    searchParams,
    format,
    handleDownloadPdf,
    loadingPdf,
    errors,
  } = useStoreVsVillagePages();
  const { t } = useTranslation();

  const byPeriod = searchParams.get('by_period');
  const byShoppingCenter = searchParams.get('by_shopping_center');
  const byCompany = searchParams.get('by_company');

  return (
    <>
      <PageHeader title={t('KPIs BRAND CROSS VILLAGE').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
              loading={loading}
            >
              {t('Export')}
            </Button>
          </Col>
          <Col>
            <Button
              onClick={() => handleDownloadPdf(title)}
              loading={loadingPdf}
              big
              icon={<PlusOutlined />}
            >
              {t('Stampa')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <bt />
        <AlertMessage
          errors={errors}
          shopRequired={true}
          searchParams={searchParams}
        />
        {byPeriod && byShoppingCenter && byCompany && (
          <Spin spinning={loading}>
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>{title}</Typography.Title>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <LineChart
                  data={data.lineChartData}
                  tableData={data.tableData}
                  colors={['#61cdbb', '#f47560', '#e8a838']}
                  itemWidth={150}
                  format={(v) => Helpers.numberWithCommas(v, ' €')}
                  formatTooltip={(v) => Helpers.numberWithCommas(v, ' €')}
                />
              </Col>
              <Divider />
              <Col span={24}>
                <Table
                  columns={UIHelper.assignTire(columns)}
                  dataSource={data.tableData}
                  pagination={{
                    pageSize: 10000,
                    position: ['bottomCenter'],
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                  }}
                  bordered
                  scroll={{ x: 1500 }}
                  summary={summary}
                  loading={loading}
                />
              </Col>
            </Row>
          </Spin>
        )}
      </div>
    </>
  );
};

export default MainPage;
